import { createSlice } from '@reduxjs/toolkit';
import { TimeSliceState, MatchTime } from './timeSliceState';
import { RootState } from '../../rootReducer';
import ls from 'localstorage-slim';

const initialState: TimeSliceState = {
  time: {
    minutes: 0,
    seconds: 0,
    stopped: false,
  },
};

export const timeSlice = createSlice({
  name: 'timeState',
  initialState,
  reducers: {
    setMatchTime(state, action) {
      state.time = action.payload;
    },
    /*stopMatchTime(state) {
      state.time.stopped = true;
    },
    resumeMatchTime(state) {
      state.time.stopped = false;
    },*/
    resetMatchTime(state, action) {
      state.time.minutes = 0;
      state.time.seconds = 0;

      emptyLocalStorage(action.payload);
    },
    emptyLocalStorage(state, action) {
      emptyLocalStorage(action.payload);
    },
  },
});

const emptyLocalStorage = (matchId?: number) => {
  if (matchId) {
    const localStorageId = `MatchWatch.${matchId}`;
    const localStorageCacheKeys = [
      `${localStorageId}.firstHalfMinutes`,
      `${localStorageId}.firstHalfSeconds`,
      `${localStorageId}.secondHalfMinutes`,
      `${localStorageId}.secondHalfSeconds`,
      `${localStorageId}.firstHalfExtraTimeMinutes`,
      `${localStorageId}.firstHalfExtraTimeSeconds`,
      `${localStorageId}.secondHalfExtraTimeMinutes`,
      `${localStorageId}.secondHalfExtraTimeSeconds`,
      `${localStorageId}.timestampFirstHalf`,
      `${localStorageId}.timestampSecondHalf`,
      `${localStorageId}.timestampFirstHalfExtraTime`,
      `${localStorageId}.timestampSecondHalfExtraTime`,
    ];

    try {
      localStorageCacheKeys.forEach((key) => ls.remove(key));
    } catch (error) {
      let message = '';
      if (error instanceof Error) {
        message = error.message;
      }
      console.log(`Error clearing local storage, details: ${message}`);
    }
  }
};

export const selectTime = (state: RootState): MatchTime => state.timeState.time;
export const selectIsMatchTimeStopped = (state: RootState): boolean => state.timeState.time.stopped;

export const timeSliceActions = timeSlice.actions;

export default timeSlice.reducer;
